<div class="row">
  <div (click)="showMe = !showMe" class="d-flex flex-grow justify-content-between no-select cursor-pointer">
    <h3 class="zero-text p-base-med">{{ 'user-self-service.konto-depot.headline' | transloco }}</h3>
    <web-design-system-icon name="chevron" [class.icon-rotate]="!showMe" />
  </div>
</div>

<form #f="ngForm" class="row opacity-container" [class.active]="showMe">
  @if (showMe && customerBaseData) {
    <div class="px-0 col-12">
      <div class="mt-3 d-flex flex-grow justify-content-between align-items-center">
        <h4 class="zero-text p-small-bold">{{ 'user-self-service.konto-depot.ref-acc.headline' | transloco }}</h4>
        <div
          [ngbTooltip]="
            (customerBaseData.refAccChangedTimestamp !== null
              ? 'user-self-service.konto-depot.btn.ongoing'
              : 'user-self-service.konto-depot.btn.change'
            ) | transloco
          "
          [openDelay]="500"
          placement="bottom"
        >
          <button class="btn btn-link p-0 mb-1" (click)="edit = !edit" [disabled]="customerBaseData.refAccChangedTimestamp !== null">
            <web-design-system-icon name="edit" />
          </button>
        </div>
      </div>
      <div class="row">
        @if (customerBaseData.refAccOwnerFullName) {
          <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.ref-acc.refAccOwnerFullName' | transloco }}</div>
          <div class="col-12 col-sm-8">{{ customerBaseData.refAccOwnerFullName }}</div>
        }

        <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.ref-acc.refAccIban' | transloco }}</div>
        <div class="col-12 col-sm-8">{{ customerBaseData.refAccIban | formateIban }}</div>
        <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.ref-acc.refAccBic' | transloco }}</div>
        <div class="col-12 col-sm-8">{{ customerBaseData.refAccBic }}</div>
        <div class="col-12 col-sm-4">
          <span class="hidden-sm hidden-md hidden-lg hidden-xl">{{ 'user-self-service.konto-depot.ref-acc.refAccBank' | transloco }}</span>
        </div>
        <div class="col-12 col-sm-8">{{ customerBaseData.refAccBank }}</div>

        @if (edit || customerBaseData.refAccChangedTimestamp) {
          <div class="col-12 mb-2">
            <hr class="border-top" />
          </div>
          <div class="col-12 mb-2">
            <h4 class="zero-text p-small-bold">{{ 'user-self-service.konto-depot.edit.headline' | transloco }}</h4>
          </div>
          <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.edit.iban' | transloco }}</div>
          <div class="col-12 col-sm-8">
            <div
              class="input-group-material margin-top-15"
              [class.input-group-material--error]="!ibanInputVar.value && ibanInputVar.touched"
            >
              <input
                #ibanInputVar="ngModel"
                type="text"
                name="ibanInput"
                id="ibanInput"
                zeroIbanInput
                required
                autofocus
                [readOnly]="customerBaseData.refAccChangedTimestamp !== null || !!dataToAuthorize"
                [disabled]="customerBaseData.refAccChangedTimestamp !== null || !!dataToAuthorize"
                [(ngModel)]="customerBaseData.refAccChangedIban"
                [class.empty]="!ibanInputVar.value"
                (ngModelChange)="changeDirectDebitMandate()"
                (bankName)="setBank($event)"
                (directDebitMandatePossible)="setDirectDebitMandatePossibility($event)"
                (displayDirectDebitMandateNotPossibleHint)="displayDirectDebitMandateNotPossibleHint($event)"
              />
              <div class="input-group-material-icon-state"></div>

              <label for="ibanInput">{{ 'user-self-service.konto-depot.edit.iban' | transloco }}:</label>

              @if (!ibanInputVar.errors) {
                <div class="input-group-material-message">&nbsp;</div>
              } @else {
                @if (!ibanInputVar.value) {
                  <div class="input-group-material-message">{{ 'user-self-service.konto-depot.edit.errors.missing' | transloco }}</div>
                }
                @if (ibanInputVar.errors['wrongFormat']) {
                  <div class="input-group-material-message">{{ 'user-self-service.konto-depot.edit.errors.wrongFormat' | transloco }}</div>
                }
                @if (ibanInputVar.errors['BLZOK']) {
                  <div class="input-group-material-message">{{ ibanInputVar.errors['BLZOK'] }}</div>
                }
              }
            </div>
            <div class="row">
              <div class="col-12 text-size-medium">{{ 'user-self-service.konto-depot.edit.hint' | transloco }}</div>
            </div>
          </div>
        }

        @if (edit) {
          <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.edit.bank' | transloco }}:</div>
          <div class="col-12 col-sm-8">
            {{ customerBaseData.refAccChangedBank ?? '—' }}
          </div>

          @if (directDebitEnabled && isDirectDebitMandatePossible) {
            <div class="mt-2 col-12 col-sm-4">
              {{ 'user-self-service.konto-depot.edit.refAccChangedNewDirectDebitMandate' | transloco }}:
              <span data-zid="info-icon" (click)="modal.open(modalContent, { size: 'md' })">
                <svg class="icon icon-16 cursor-pointer color-secondary">
                  <use xlink:href="/assets/img/svgs/svgset.svg#info" />
                </svg>
              </span>
              <ng-template #modalContent let-modal>
                <web-design-system-modal
                  [headline]="'user-self-service.konto-depot.edit.refAccChangedNewDirectDebitMandate' | transloco"
                  (dismiss)="modal.dismiss('Cross click')"
                >
                  <p>{{ 'user-self-service.konto-depot.edit.teaser-text' | transloco }}</p>
                </web-design-system-modal>
              </ng-template>
            </div>
            <div class="mt-2 col-12 col-sm-8 d-flex align-items-start">
              <web-design-system-switch
                [disabled]="!!dataToAuthorize"
                [checked]="customerBaseData.refAccChangedNewDirectDebitMandate"
                (checkedChange)="changeDirectDebitMandate($event)"
              />

              @if (withoutDirectDebitMandateHint) {
                <div class="ml-2 zero-text course-red">
                  {{ 'user-self-service.konto-depot.edit.without-direct-debit-mandate-hint' | transloco }}
                </div>
              }
            </div>
          }

          <div class="col-12 mt-3">
            @if (!dataToAuthorize) {
              @if (directDebitMandatePossibleHint) {
                <div class="mb-2 zero-text course-red">
                  {{ 'user-self-service.konto-depot.edit.direct-debit-mandate-not-possible-hint' | transloco }}
                </div>
              }
              <web-design-system-button [disabled]="!f.valid" size="small" (click)="startChangeRefAccount()">
                {{ 'user-self-service.konto-depot.edit.btn' | transloco }}
              </web-design-system-button>
            } @else {
              <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
            }
          </div>
        }

        <div class="col-12 mt-4">
          <div class="row">
            <div class="col-12 mb-2">
              <h4 class="zero-text p-small-bold">{{ 'user-self-service.konto-depot.depot.headline' | transloco }}</h4>
            </div>
            <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.depot.name' | transloco }}</div>
            <div class="col-12 col-sm-8">{{ currentCustomer.firstName }} {{ currentCustomer.lastName }}</div>
            <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.depot.custId' | transloco }}</div>
            <div class="col-12 col-sm-8">{{ currentCustomer.custId }}</div>
            <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.depot.dep' | transloco }}</div>
            <div class="col-12 col-sm-8">{{ currentCustomer.dep }}</div>
            <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.depot.bic' | transloco }}</div>
            <div class="col-12 col-sm-8">
              <web-design-system-copy-to-clipboard
                label="BDWBDEMMXXX"
                iconCssClass="icon-dark"
                [hint]="'mydepot.deposit.copy-bic' | transloco"
              />
            </div>
            <div class="col-12 col-sm-4">
              <span class="hidden-sm hidden-md hidden-lg hidden-xl">
                {{ 'user-self-service.konto-depot.depot.bic' | transloco }}
              </span>
            </div>
            <div class="col-12 col-sm-8">{{ 'mydepot.deposit.baaderbank' | transloco }}</div>
            @if (customerStateFacade.customerAccountData$ | async; as customerAccount) {
              <div class="col-12 col-sm-4">{{ 'user-self-service.konto-depot.depot.accountIban' | transloco }}</div>
              <div class="col-12 col-sm-8">
                <web-design-system-copy-to-clipboard
                  [label]="customerAccount.accountIban | formateIban"
                  iconCssClass="icon-dark"
                  [hint]="'mydepot.deposit.copy-iban' | transloco"
                />
              </div>
            }
          </div>
          <div class="row mt-3">
            <div class="col">
              <p>{{ 'user-self-service.konto-depot.depot.hint' | transloco }}</p>
            </div>
          </div>
        </div>

        <div class="col-12">
          <web-components-user-messages />
        </div>

        <div class="col-12 mb-2"><hr class="border-top" /></div>
        <div class="col-12">
          <h4 class="mb-2 zero-text p-small-bold">{{ 'user-self-service.konto-depot.depot.sepa.headline' | transloco }}</h4>
          <web-design-system-switch
            [label]="'user-self-service.konto-depot.depot.sepa.label' | transloco"
            [checked]="sepaFacade.hasSepa$ | async"
            [disabled]="sepaFacade.loading$ | async"
            (checkedChange)="toggleSepa($event)"
          />
          @if (sepaFacade.errorMessage$ | async; as errorMessage) {
            <div class="mt-2">
              <div class="font-regular font-size-smaller1 text-color-error">{{ errorMessage }}</div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</form>
